export default __webpack_public_path__ + "static/media/14.59490859.png";